export default "__VITE_ASSET__D7KuPkF2__"